export default {
    '/mortgage': require('./mortgage'),
    '/budget-planner': require('./budget-planner'),
    '/loan': require('./loan'),
    '/prosperity-planner': require('./prosperity'),
    '/financial-planning': require('./financial-planning'),
    '/education-planning': require('./education-planning'),
    '/retirement-planning': require('./retirement-planning'),
    '/investing-taxes': require('./investing-taxes'),
};
